export const SET_USER_INFO = 'APP/SET_USER_INFO'
export const FETCH_TICKETS_COUNTER = 'APP/FETCH_TICKETS_COUNTER'
export const SET_I18N = 'APP/SET_I18N'
export const SET_TICKETS_COUNTER = 'APP/SET_TICKETS_COUNTER'
export const SET_APP_DATA = 'APP/SET_APP_DATA'
export const DROP_USER_DATA = 'APP/DROP_USER_DATA'
